import utils from '@bigcommerce/stencil-utils';
import ProductDetails from '../common/product-details';
import { defaultModal, ModalEvents } from './modal';

export default function (context) {
    const modal = defaultModal();

    $('.wishlist-modal, .wishlist-modal-link').on('click', event => {
        event.preventDefault();

        const productId = $(event.currentTarget).data('product-id');

        modal.open({ size: 'small' });

        const content = $(`[data-wishlist-modal-content][data-id="${productId}"]`)

        modal.updateContent($(content).html());
    });

    function getCart(url) {
        return fetch(url, {
            method: "GET",
            credentials: "same-origin"
        })
        .then(response => response.json());
    };

    $('#save-cart').on('click', event => {
        event.preventDefault();

        modal.open({ size: 'small' });
        const content = $(`[data-wishlist-modal-save-cart-content]`)
        modal.updateContent($(content).html());

        const savecartModalLinkHandler = event => {
            event.preventDefault();
            const $select = $(event.currentTarget);

            if (context.cartId) {
                const addUrl = $select.data('add-url');
                const viewUrl = $select.data('view-url');
                const name = $select.val();
                modal.pending = true;

                getCart('/api/storefront/carts').then(data => {
                    let ids = [];
                    const cartContent = data[0];
                    for (let [key, value] of Object.entries(cartContent.lineItems)) {
                        for (let item of value) {
                            ids.push(item.productId);
                        }
                    }

                    if (ids) {
                        for (let id of ids) {
                            $.post(addUrl + '&product_id=' + id);
                        }
                        let $div = $("<div>", {"class": "wishlist-modal"});
                        const overlayContent = '<p><strong>Cart Items added to ' + name + '</strong><p>';
                        const overlayButton = '<a href=' + viewUrl + '>View Wishlist - ' + name + '</a>';
                        $div.append(overlayContent).append(overlayButton)
                        modal.pending = false;
                        modal.updateContent($div);
                    } else {
                        let $div = $("<div>", {"class": "wishlist-modal"});
                        $div.append('<p><strong>' + context.genericError + '</strong><p>');
                        modal.pending = false;
                        modal.updateContent($div);
                    }
                })
                .catch(error => console.error(error));

            } else {
                alert(context.genericError);
            }
        }

        $('[data-save-cart-link]').on('click', savecartModalLinkHandler);
    });
}
